/**
 * splash.js
 *
 * Hides the native Capacitor splash screen.
 *
 * capacitor.config.ts sets launchAutoHide: false, so the native splash stays up
 * until something calls this. That is deliberate: autohiding on a fixed timer
 * either covers a ready app (wasted seconds) or uncovers an unready one (a
 * flash of empty page). Hiding it when auth resolves makes it last exactly as
 * long as the app needs.
 *
 * Because nothing else takes it down, a failure to reach the call site would
 * leave the splash up forever. index.js arms a watchdog that fires regardless
 * of what React does, and hide() is idempotent, so the two callers cannot
 * conflict.
 *
 * On web the plugin is a no-op, so this is safe to call on every platform.
 */
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

export async function hideNativeSplash() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await SplashScreen.hide();
  } catch {
    // Already hidden, or the plugin is unavailable. Either way there is
    // nothing to recover from and nothing worth logging on a user's device.
  }
}
